import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import { isEqual, isEmpty, find } from "@utils/lodash";

class Select extends Component {
	constructor(props) {
		super(props);

		const { options, value: rawValue } = this.props;

		let value = null;

		if (rawValue !== null) {
			value = find(options, ["value", rawValue]) || null;
		}

		this.state = {
			value,
		};
	}

	static getDerivedStateFromProps(nextProps, lastState) {
		const newState = {};
		let value = null;

		if (nextProps.value !== null) {
			value = find(nextProps.options, ["value", nextProps.value]) || null;
		}

		if (!isEqual(value, lastState.value)) {
			newState.value = value;
		}

		return !isEmpty(newState) ? newState : null;
	}

	render() {
		const {
			className,
			id,
			classNamePrefix,
			autoFocus,
			isDisabled,
			isMulti,
			isSearchable,
			isClearable,
			placeholder,
			isLoading,
			options,
			name,
			onChange,
			onInputChange,
			onMenuClose,
		} = this.props;
		const { value } = this.state;

		return (
			<ReactSelect
				className={className}
				id={id}
				classNamePrefix={classNamePrefix}
				autoFocus={autoFocus}
				isDisabled={isDisabled}
				isMulti={isMulti}
				isSearchable={isSearchable}
				isClearable={isClearable}
				placeholder={placeholder}
				isLoading={isLoading}
				options={options}
				name={name}
				value={value}
				onChange={onChange}
				onInputChange={onInputChange}
				onMenuClose={onMenuClose}
			/>
		);
	}
}

Select.propTypes = {
	value: PropTypes.any,
	options: PropTypes.array.isRequired,
	id: PropTypes.string,
	className: PropTypes.string,
	classNamePrefix: PropTypes.string,
	autoFocus: PropTypes.bool,
	isDisabled: PropTypes.bool,
	isMulti: PropTypes.bool,
	isSearchable: PropTypes.bool,
	isClearable: PropTypes.bool,
	name: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	isLoading: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	onInputChange: PropTypes.func,
	onMenuClose: PropTypes.func,
};

Select.defaultProps = {
	className: "react-select",
	id: undefined,
	classNamePrefix: "react-select",
	autoFocus: false,
	isDisabled: false,
	isMulti: false,
	isSearchable: true,
	isClearable: false,
	placeholder: "Select...",
	isLoading: false,
	value: null,
	onInputChange: () => {},
	onMenuClose: () => {},
};

export default Select;
